import { create } from 'zustand';

const defaultPagination = { page: 1, pageSize: 20, total: 0, totalPages: 1 };

export const useDelegationStore = create((set) => ({
    items: [],
    mine: [],
    incoming: [],
    actingPrincipalIds: [],
    loading: false,
    error: null,
    columnFilters: {},
    uniqueValues: {},
    paginationData: { ...defaultPagination },
    searchParams: { status: '', delegatorId: '', delegateeId: '' },
    selectedItem: null,
    isCreateDialogOpen: false,
    isAdminCreateDialogOpen: false,
    setItems: (items) => set({ items }),
    setMine: (mine) => set({ mine }),
    setIncoming: (incoming) => set({ incoming }),
    setActingPrincipalIds: (actingPrincipalIds) => set({
        actingPrincipalIds: Array.isArray(actingPrincipalIds) ? actingPrincipalIds : [],
    }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    setPaginationData: (paginationData) => set({ paginationData }),
    setSearchParams: (searchParams) => set((s) => ({ searchParams: { ...s.searchParams, ...searchParams } })),
    setSelectedItem: (selectedItem) => set({ selectedItem }),
    setIsCreateDialogOpen: (isCreateDialogOpen) => set({ isCreateDialogOpen }),
    setIsAdminCreateDialogOpen: (isAdminCreateDialogOpen) => set({ isAdminCreateDialogOpen }),
    resetAdminQuery: () =>
        set({
            searchParams: { status: '', delegatorId: '', delegateeId: '' },
            paginationData: { ...defaultPagination },
        }),
}));

export default useDelegationStore;
